import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import React from 'react';
import { useLocation } from 'react-router-dom';

const PriceBreakup = ({ priceDetails, selectedPaymentMethod }) => {
  const location = useLocation();

  
  return (
    <div className="w-full h-fit sticky top-15">
      {/* Delivery Address Section */}
      <div
        className={`w-full flex gap-2 p-3 bg-white rounded-lg mb-2 items-center ${
          location?.pathname === "/checkout/payment" ? "shadow-sm" : ""
        }`}
      >
        <div className="w-8 h-8 rounded-full p-1 flex items-center justify-center bg-red-100">
          <LocationOnRoundedIcon className="text-red-600" fontSize="small" />
        </div>
        <span>Deliver to</span>
        <span>Sanfransisco - 14256</span>
      </div>

      {/* Price Details Section */}
      <div
        className={`w-full h-fit bg-white rounded-xl md:px-2 max-sm:px-4 py-4 md:p-4 ${
          location?.pathname === "/checkout/payment" ? "shadow-md" : ""
        }`}
      >
        {/* Price Breakdown */}
        <div className="flex justify-between mb-4 text-zinc-600">
          <span>Sub Total</span>
          <span>₹{priceDetails?.MRP}</span>
        </div>
        <div className="flex justify-between mb-4 text-zinc-600">
          <span>Shipping</span>
          <span>Free</span>
        </div>
        <div className="flex justify-between md:pb-4 md:border-b-[1px] text-zinc-600">
          <span>Discount</span>
          <span>₹{priceDetails?.discount}</span>
        </div>
        <div className="flex justify-between mt-4 max-md:hidden">
          <span>Total</span>
          <span>₹{priceDetails?.totalAmount}</span>
        </div>

       
      </div>

      
    </div>
  );
};

export default PriceBreakup;
